import React, {useState} from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/react'

const pillFilledWrapperStyles = css`
  border-radius: 999px;
  background: #dde1eac2;
  padding: 2px 4px;
  gap: 0;
`

const ToggleWrapper = styled.div`
  display: ${({fullWidth}) => (fullWidth ? 'flex' : 'inline-flex')};
  width: ${({fullWidth}) => (fullWidth ? '100%' : 'auto')};
  align-items: center;
  background: #f3f4f8;
  padding: 3px;
  gap: 2px;
  border-radius: 8px;
  ${({variant}) => variant === 'pillFilled' && pillFilledWrapperStyles}
`

const ToggleTab = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  flex: ${({fullWidth}) => (fullWidth ? 1 : 'none')};
  transition:
    background 0.2s,
    color 0.2s;

  ${({variant, isActive}) =>
    variant === 'pillFilled' &&
    css`
      border-radius: 999px;
      background: ${
        isActive
          ? 'radial-gradient(57.14% 57.14% at 50% 92.86%, #5378FC 0%, #29355D 100%)'
          : 'none'
      };
      box-shadow: ${isActive ? '0px 3px 5.3px 0px #0000002E' : 'none'};
      color: ${isActive ? '#ffffff' : '#3D5199'};
      font-family: 'Inter', sans-serif;
      font-weight: ${isActive ? 700 : 400};
      font-size: 12px;
      height: auto;
      padding: 10px 20px;
      gap: ${isActive ? '12px' : '6px'};
    `}
`

export function Toggle({
  tabs = [],
  variant = 'default',
  defaultIndex = 0,
  activeIndex: controlledIndex,
  onChange,
  renderTab,
  fullWidth = false,
  ...props
}) {
  const isControlled = controlledIndex !== undefined
  const [internalIndex, setInternalIndex] = useState(defaultIndex)
  const resolvedIndex = isControlled ? controlledIndex : internalIndex

  const handleClick = (tab, idx) => {
    if (!isControlled) setInternalIndex(idx)
    onChange?.(tab, idx)
  }
  return (
    <ToggleWrapper
      variant={variant}
      role="tablist"
      fullWidth={fullWidth}
      {...props}
    >
      {tabs.map((tab, idx) => (
        <ToggleTab
          key={tab.value}
          role="tab"
          variant={variant}
          isActive={idx === resolvedIndex}
          aria-selected={idx === resolvedIndex}
          onClick={() => handleClick(tab, idx)}
          fullWidth={fullWidth}
        >
          {renderTab ? renderTab(tab, idx === resolvedIndex) : tab.label}
        </ToggleTab>
      ))}
    </ToggleWrapper>
  )
}
